export default "__VITE_ASSET__pbPoacqJ__"